import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import app from "./modules/app";
import user from "./modules/user";
import plan from "./modules/plan";
import payment from "./modules/payment";
import mutations from "./mutation-types";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    app,
    user,
    plan,
    payment,
  },
  plugins: [createPersistedState()],
});
export default store;

export function clear() {
  mutations.forEach((type) => {
    store.commit(type, null);
  });
  console.log(mutations);
}



// WEBPACK FOOTER //
// ./src/store/index.js